export class removeProbmelDto {
    problemId: number;
    description: string;
}